import styled from 'styled-components';

export default styled.div`
  border-left: 1px solid ${props => props.theme.lightGray1};
  height: ${props => props.theme.buttonHeightSmall}px;
  margin-left: ${props => props.theme.gridSize}px;
  margin-right: ${props => props.theme.gridSize}px;
`;
